export { default } from './parsePropName'
export * from './parsePropName'
